export default __webpack_public_path__ + "static/backgroundArchive--blurV-94f605aa516824513acd962a6ee28c9c.webp";